// cookie通用方法
// import Cookies from 'js-cookie'

export function getCookie (key) {
  // return Cookies.get(key)
  return localStorage.getItem(key)
}

export function setCookie (key, value) {
  // return Cookies.set(key, value)
  localStorage.setItem(key, value)
}

export function removeCookie (key) {
  // return Cookies.remove(key)
  localStorage.removeItem(key)
}
